module.exports = __webpack_public_path__ + "static/media/background-open.84279bd0.jpg";